import moment from 'moment';
import { createSelector } from 'reselect';
import { InboundSMS, InboundSMSReducerState } from './types';

/**
 * inboundSMSSelector
 * Selector for the inboundSMS state.
 */
export const inboundSMSSelector = (state: InboundSMSReducerState) => state.insights.inboundSMS;

/**
 * selectInboundSMSMessages
 * Selects the inboundSMSMessages from the inboundSMS state.
 */
export const selectInboundSMSMessages = createSelector([inboundSMSSelector], (inboundSMS) =>
  inboundSMS.inboundSMSMessages.map((message: InboundSMS, i: number) => {
    /** It was discovered that Safari cannot interpret the date format `yyyy-MM-DD hh:mm:ss +00:00`
     * due to the space before `+00:00`. The space technically does not comply with ISO 8601 standard,
     * even though Chrome has no problem parsing it. Reformat to match standard. */
    const formattedDate = moment(message.createdAt, 'yyyy-MM-DD hh:mm:ss Z').toDate().toISOString();
    return {
      ...message,
      /** Since no unique identifier is returned from the API endpoint, we need to add our own so that the table data displays correctly. */
      id: i,
      createdAt: formattedDate,
    };
  }),
);
